import { create } from 'zustand'
import type { FiltersState, FiltersStore } from './filters.types'

const initialFilters: FiltersState = {
  orderBy: 'default',
  state: 'all',
  usage: 'all',
  city: 'all',
  priceMin: undefined,
  priceMax: undefined,
  neighborhood: undefined,
  search: undefined,
  view: 'list',
}

export const useFiltersStore = create<FiltersStore>((set) => ({
  filters: initialFilters,
  setFilters: (newFilters: FiltersState) =>
    set(() => ({ filters: newFilters })),
  resetFilters: () => set(() => ({ filters: initialFilters })),
}))
